// js
import React from 'react';
import PropTypes from 'prop-types';
import formattingUtils from '../../utils/formattingUtils';
import FormattedGB from '../common/FormattedGB';
import Toggle from 'react-toggle';
import AreaCard from '../common/AreaCard';


function SourcesCard({area, dsa, progress, toggle, canToggle, canActivateArea, stats, isActiveArea, canViewTotalIndexed}) {
  let handleChange = () => {
    const dsaArea = dsa.dsaAreas.find(a => a.area === area.id);
    toggle(dsaArea.id, !dsaArea.active);
  };
  const isToggleChecked = canActivateArea && isActiveArea;
  const isToggleDisabled = !canActivateArea || (!canToggle && isActiveArea);

  return (
    <AreaCard area={area}>
      <Toggle
        checked={isToggleChecked}
        onChange={handleChange}
        disabled={isToggleDisabled}
      />
      <p>
        <span className='area-card__answered sources-card__answered'>
          {isActiveArea && (progress.current === progress.total) && <i className='icon icon-check-green' /> }
          {isActiveArea ? `${progress.current}/${progress.total} Complete` : 'n/a'}
        </span>
      </p>
      <p className='area-card__sources'>
        {canViewTotalIndexed &&
          <span className='area-card__data'>
            {isActiveArea ? <FormattedGB value={stats.dataRequired} perDay /> : 'n/a' }
          </span>
        }
        {canViewTotalIndexed && isActiveArea &&
          <span className='area-card__data area-card__data--cisco-split'>
            <span className='area-card__data--non-cisco'>
              <FormattedGB value={stats.nonCiscoDataPerDay} perDay /> Non Cisco
            </span>
            <span className='area-card__data--cisco'>
              <FormattedGB value={stats.ciscoDataPerDay} perDay /> Cisco Data
            </span>
          </span>
        }
        {canViewTotalIndexed && isActiveArea &&
          <span className='area-card__data area-card__data--cisco-split area-card__data--cisco-indexed'>
            <span className='area-card__data--non-cisco'>
              <FormattedGB value={stats.nonCiscoDataIndexed} perDay /> Non Cisco indexed
            </span>
            <span className='area-card__data--cisco'>
              <FormattedGB value={stats.ciscoDataIndexed} perDay /> Cisco Data indexed
            </span>
          </span>
        }
        {canViewTotalIndexed &&
          <span>{isActiveArea ? `${stats.percentIndexed }% Indexed` : 'n/a'}</span>
        }
        <span>{isActiveArea ? `${formattingUtils.numberWithCommas(stats.configuredItems)} Configured Items` : 'n/a'}</span>
      </p>
    </AreaCard>
  );
}

SourcesCard.propTypes = {
  area: PropTypes.object.isRequired,
  dsa: PropTypes.object,
  isActiveArea: PropTypes.bool,
  stats: PropTypes.object,
  progress: PropTypes.object,
  canViewTotalIndexed: PropTypes.bool.isRequired,
  toggle: PropTypes.func,
  canToggle: PropTypes.bool,
  canActivateArea: PropTypes.bool
};

export default SourcesCard;



// WEBPACK FOOTER //
// ./src/components/sources/SourcesCard.js